import Axios from "axios";
import { getIdpApiBase } from "./idpBase";
import {
	buildRegistrationBody,
	buildMerchantUpdateRequestBody,
	resolveMerchantSearchMode,
} from "./idpHelpers";
import { forgotPasswordApi, resetPasswordApi } from "./Auth";

/** Sandbox sign-up stays on monolith until backend confirms otherwise. */
export const registerSandboxMerchantApi = ({
	email,
	phoneNumber,
	firstName,
	lastName,
	merchantName,
	merchantType,
	password,
	address,
	countryId,
	cityId,
	stateProvinceId,
	typeOfIndustry,
	numberOfCustomer,
	monthlyTransactionFrequency,
	monthlyTransactionAmount,
	postalCode,
	token,
}) => {
	return Axios({
		method: "post",
		url: window.sandboxApiURL + "merchant/register",
		data: {
			email: email,
			phoneNumber: phoneNumber,
			firstName: firstName,
			lastName: lastName,
			merchantName: merchantName,
			merchantType: merchantType,
			typeOfIndustry: typeOfIndustry,
			numberOfCustomer: numberOfCustomer,
			monthlyTransactionFrequency: monthlyTransactionFrequency,
			monthlyTransactionAmount: monthlyTransactionAmount,
			password: password,
			address: address,
			countryId: countryId,
			cityId: cityId,
			stateProvinceId: stateProvinceId,
			postalCode: postalCode,
			isDeposit: -1,
			token: token,
			environment: 0,
		},
		headers: {
			"Content-Type": "application/json",
		},
	});
};

/** Production sign-up — public, no token. */
export const registerMerchantApi = (payload) => {
	return Axios({
		method: "post",
		url: getIdpApiBase() + "v2/merchant/registrations",
		data: buildRegistrationBody(payload),
		headers: {
			"Content-Type": "application/json",
		},
	});
};

export const viewMerchantApi = ({ authToken, deviceId, merchantId }) => {
	if (authToken != null && merchantId != null) {
		return Axios({
			method: "get",
			url: getIdpApiBase() + "v2/merchant/" + merchantId,
			params: {
				additionalFields: true,
			},
			headers: {
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

export const searchSubMerchantApi = ({ authToken, deviceId, userId, merchantId }) => {
	if (authToken != null) {
		return Axios({
			method: "get",
			url: window.ApiURLNew + "merchant/submerchant/search",
			params: {
				userId: userId,
				merchantId: merchantId,
			},
			data: {},
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

export const updateMerchantApi = ({ authToken, deviceId, merchantId, data }) => {
	if (authToken != null && merchantId != null) {
		return Axios({
			method: "put",
			url: getIdpApiBase() + "v2/merchant/" + merchantId,
			data: buildMerchantUpdateRequestBody(data),
			headers: {
				"Content-Type": "application/json",
				authToken: authToken,
				deviceUniqueId: deviceId || "Portal",
			},
		});
	}
};

export const getListCurrencyApi = ({
	authToken,
	deviceId,
	merchantId,
	paramCurrencyPoint,
}) => {
	if (authToken != null && merchantId != null) {
		const type =
			paramCurrencyPoint === 0 || paramCurrencyPoint === '0' ? 'POINT' : 'CURRENCY';
		return Axios({
			method: "get",
			url: getIdpApiBase() + "v2/merchant/" + merchantId + "/currencies",
			params: {
				type,
			},
			headers: {
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

export const getCurrencyApi = ({ authToken, deviceId, userId, merchantId, currencyId }) => {
	if (authToken != null) {
		return Axios({
			method: "get",
			url: window.ApiURL + "merchant/currency",
			params: {
				userId: userId,
				merchantId: merchantId,
				currencyId: currencyId,
			},
			data: {},
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

/** Activation link — public, no token. */
export const verificationMerchantApi = ({ userId, merchantId, code }) => {
	return Axios({
		method: "post",
		url: getIdpApiBase() + "v2/merchant/registrations/verification",
		data: {
			userId: userId,
			merchantId: merchantId,
			verificationCode: code,
		},
		headers: {
			"Content-Type": "application/json",
		},
	});
};

export const verificationForgotMerchantApi = (payload) => forgotPasswordApi(payload);

export const verificationForgotPasswordMerchantApi = (payload) => resetPasswordApi(payload);

export const activateSandboxApi = ({ authToken, deviceId, merchantId }) => {
	if (authToken != null && merchantId != null) {
		return Axios({
			method: "put",
			url: getIdpApiBase() + "v2/merchant/" + merchantId + "/sandbox",
			headers: {
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};
export const searchMerchantApi = (params) => {
	const {
		authToken,
		deviceId,
		page,
		merchantCode,
		merchantName,
	} = params || {};
	if (authToken != null) {
		return Axios({
			method: "get",
			url: getIdpApiBase() + "v2/merchant/search",
			params: {
				mode: resolveMerchantSearchMode(params),
				page: page != null ? page : 0,
				pageSize: 999,
				merchantCode: merchantCode || "",
				merchantName: merchantName || "",
			},
			headers: {
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

export const merchantPaymentTypeApi = ({ authToken, deviceId, userId, merchantId }) => {
	if (authToken != null) {
		return Axios({
			method: "get",
			url: window.ApiURLNew + "merchant/payment/type",
			params: {
				userId: userId,
				merchantId: merchantId,
			},
			data: {},
			headers: {
				// "Content-Type": "application/x-www-form-urlencoded",
				authToken: authToken,
				deviceUniqueId: deviceId,
			},
		});
	}
};

export const getSearchMerchantApi = ({ merchantCode, merchantName, keyword, page, pageSize, authToken, deviceId }) => {
	return Axios({
		method: "get",
		url: getIdpApiBase() + "v2/merchant/search",
		params: {
			mode: "ALL",
			merchantCode: merchantCode || "",
			merchantName: merchantName || keyword || "",
			page: page != null ? page : 0,
			pageSize: pageSize != null ? pageSize : 10,
		},
		headers: {
			authToken: authToken,
			deviceUniqueId: deviceId || "Portal",
		},
	});
};
